import DisplayScheduleList from "../../components/DisplayScheduleList";

const DisplayScheduleListPage = () => {
  return <DisplayScheduleList />;
};

export default DisplayScheduleListPage;
